<template>
  <offer-service-form :id="id" />
</template>

<script>
import OfferServiceForm from "./OfferServiceForm.vue";

export default {
  components: { OfferServiceForm },
  props: {
    id: { type: String, required: true },
  },
};
</script>
